import CustomerServiceContact from 'customerService/customerServiceContact';
import CustomerServiceSearchForm from 'customerService/CustomerServiceSearchForm';
import RecaptchaFormControl from 'account/RecaptchaFormControl';
import FormControlWithBtnDisablingAndRecaptcha from 'global/form/formControlWithBtnDisablingAndRecaptcha';

const customerServiceContactForm = document.getElementById(
	'KnowledgeBaseContactUsForm',
);

if (customerServiceContactForm) {
	new CustomerServiceContact();
	new FormControlWithBtnDisablingAndRecaptcha(customerServiceContactForm);
	new RecaptchaFormControl(customerServiceContactForm);
}

const customerServiceSearchFormNode = document.querySelector(
	'[data-id="customerServiceSearchForm"]',
);
if (customerServiceSearchFormNode) {
	new CustomerServiceSearchForm();
}
